import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import type { MenuItem } from '../../types/workspace';
import { useRestaurant } from '../../context/RestaurantContext';
import SmartImagePreview from '../shared/SmartImagePreview';

interface MenuItemRowProps {
  item: MenuItem;
  href?: string;
  showDescription?: boolean;
}

const MenuItemRow: React.FC<MenuItemRowProps> = ({ item, href, showDescription = true }) => {
  const { formatMoney } = useRestaurant();
  const content = (
    <>
      <div className="flex items-center gap-4 pr-4">
        {item.imageUrl && (
          <SmartImagePreview src={item.imageUrl} alt={item.imageAlt || item.name} className="h-20 w-20 shrink-0" />
        )}
        <div>
          <div className="text-lg font-semibold text-white transition-colors group-hover:text-amber-200">
            {item.name}
          </div>
          {showDescription && item.description && (
            <div className="mt-1 max-w-3xl text-sm leading-6 text-white/50">{item.description}</div>
          )}
          {!item.isAvailable && (
            <div className="mt-2 inline-flex rounded-full border border-red-300/20 bg-red-500/10 px-2 py-1 text-[10px] uppercase tracking-[0.22em] text-red-200">
              Unavailable
            </div>
          )}
        </div>
      </div>
      <div className="flex items-center gap-4">
        <div className="arab-price-pill">{formatMoney(item.price)}</div>
        {href && <ChevronRight className="h-4 w-4 text-amber-300/60 transition-transform group-hover:translate-x-1" />}
      </div>
    </>
  );

  if (!href) {
    return <div className="arab-list-row">{content}</div>;
  }

  return (
    <Link to={href} className="arab-list-row group block">
      {content}
    </Link>
  );
};

export default MenuItemRow;
